var exports = {
  "k": "x61f99309--9b7395--container",
  "E": "x61f99309--9b7395--notification",
};

module.exports = exports;
